export default __webpack_public_path__ + "locales/fr/SharingPanel.json?hash=28d7a75ab532b6cc3f156e07ecbc9297";